import script from "./ModalTableShop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalTableShop.vue?vue&type=script&setup=true&lang=ts"

import "./ModalTableShop.vue?vue&type=style&index=0&id=2c0058d1&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0058d1"]])

export default __exports__